// Redux reducer to store if navigation is from login
const initialState = {
  fromLogin: false
};

const fromLoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_FROM_LOGIN":
      return { ...state, fromLogin: action.payload };
    case "PASSWORD":
      return { ...state, password: action.payload };
    case "CLEAR_PASSWORD":
      return { ...state, password: "" };
    default:
      return state;
  }
};

export default fromLoginReducer;
